import {useEffect, useRef, useState} from 'react';
import {getCapitalMessage} from '@di-shared/features/capital/capitalMessage';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {UserOsType} from '@shared/cci/features/const/environment';
import {useQueryClient} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {diApi} from '@di-shared/api/di';

export default function useCapitalMessage(vin: string, to: string, isInitMounted: boolean = false) {
  const queryClient = useQueryClient();
  const os = useEnvironmentStore((state) => state.os);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [isMounted, setIsMounted] = useState(isInitMounted);

  useEffect(() => {
    if (!iframeRef.current) {
      return;
    }
    const targetUrl = new URL(to);
    const {requests, listenCapitalMessage, releaseCapitalMessage} = getCapitalMessage({
      iframeEl: iframeRef.current,
      vin,
      origin: targetUrl.origin,
      async invalidate() {
        await queryClient.invalidateQueries({queryKey: [getQueryKey(diApi.vehicle.getVehicle)]});
      },
      onMounted() {
        setIsMounted(true);
      },
    });

    listenCapitalMessage();
    if (os === UserOsType.AOS) {
      window.onBackButton = () => {
        requests.androidBackClicked();
      };
    }

    return () => {
      releaseCapitalMessage();
      if (os === UserOsType.AOS) {
        // @ts-ignore
        window.onBackButton = undefined;
      }
    };
  }, [os, to, vin]);

  return {
    iframeRef,
    isMounted,
  };
}
